<template>
<div>
  <v-data-table
    :headers="changeCategoryMOCTypeHeaders"
    :items="filteredItems"
    style="border: solid 1px;"
    :show-select="showSelect"
  >
    <template v-slot:top>
      <v-row dense class="px-3">
        <v-col cols="6">
          <v-autocomplete
            :items="mocTypes"
            variant="underlined"
            item-title="value"
            item-value="clientID"
            return-object
            label="Moc Type"
            hide-no-data
            v-model="mocType"
            hide-selected
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-autocomplete
            :items="changeCategories"
            variant="underlined"
            item-title="name"
            item-value="clientID"
            return-object
            label="Change Category"
            hide-no-data
            v-model="changeCategory"
            hide-selected
            clearable
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row justify="end" dense>
        <v-col cols="12" sm="3" class="py-0 mr-3" style="display: flex; justify-content: flex-end">
          <div v-if="showSelect">
            <v-btn small color="green" class="white--text mr-2" @click="next()"><v-icon>mdi-check</v-icon>Continue</v-btn>
            <v-btn small color="red" class="white--text" @click="cancel"><v-icon>mdi-close</v-icon>Cancel</v-btn>
          </div>
          <v-menu top close-on-click v-if="readonly ? false : !showSelect">
            <template v-slot:activator="{ props }">
              <v-btn color="primary" class="white-text" small v-bind="props">
                Bulk Actions <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="addFAT">
                <v-list-item-title>Add Approvers, FYIs, Tasks</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </template>
    <template v-slot:header.data-table-select="{ on, props }">
      <v-checkbox
        color="green"
        :model-value="selected && selected.length === 0 ? false : selected && filteredItems.length === selected.length"
        @update:modelValue="onMultiSelectChange($event)"
        :indeterminate="selected && selected.length > 0 && filteredItems.length !== selected.length"
      ></v-checkbox>
    </template>
    <template v-slot:item="props">
      <tr>
        <td v-if="showSelect">
          <v-checkbox
            color="green"
            :model-value="props.item.isSelected"
            hide-details
            @update:modelValue="onItemCheckboxChange($event, props.item)"
          ></v-checkbox>
        </td>
        <td>
          <a @click="editChangeCategoryMOCType(props.item)" class="blue-link">{{ props.item.value }}</a>
        </td>
        <td>{{ props.item.changeCategory.name || '' }} {{ props.item.changeCategory.enabled ? '' : '(Disabled)' }}</td>
        <td>{{ props.item.approvers ? props.item.approvers.length : 0 }}</td>
        <td>{{ props.item.fyis ? props.item.fyis.length : 0 }}</td>
        <td>{{ props.item.displayOrder }}</td>
        <td>{{ (props.item.tasks || []).length }}</td>
        <td><v-icon color="red" @click="deleteChangeCategoryMOCType(props.item)">mdi-delete-outline</v-icon></td>
      </tr>
    </template>
  </v-data-table>
  <v-dialog persistent v-model="showConfirmationDialog" max-width="500">
      <v-card v-if="showConfirmationDialog">
        <v-container>
          <h3>Are you sure you want to delete '{{ selectedChangeCategoryMOCType.name }}' ?</h3>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="red" text @click="onDeleteConfirmation">Yes</v-btn>
            <v-btn color="black" text @click="cancelDeletion">No</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
  name: 'ChangeCategoryMocTypeTable',
  props: {
    changeCategoryMocTypes: Array,
    changeCategories: Array,
    mocTypes: Array,
    readonly: Boolean
  },
  data() {
    return {
      changeCategoryMOCTypeHeaders: [
        {
          title: 'MOC Type',
          key: 'value'
        },
        {
          title: 'Change Category',
          key: 'changeCategory.name'
        },
        {
          title: 'Approvers',
          key: 'approvers.length'
        },
        {
          title: 'FYIs',
          key: 'fyis.length'
        },
        {
          title: 'Display Order',
          key: 'displayOrder'
        },
        {
          title: 'Tasks',
          key: 'tasks.length'
        }
      ],
      mocType: undefined,
      changeCategory: undefined,
      selectedChangeCategoryMOCType: undefined,
      showConfirmationDialog: false,
      showSelect: false,
      selected: [],
      next: () => {}
    }
  },
  computed: {
    filteredItems() {
      let result = this.changeCategoryMocTypes

      if (this.mocType) {
        result = result.filter(r => r.clientID === this.mocType.clientID)
      }

      if (this.changeCategory) {
        result = result.filter(r => r.changeCategory.clientID === this.changeCategory.clientID)
      }

      return result.map(r => ({ ...r, isSelected: this.selected.findIndex(s => s.clientID === r.clientID) !== -1 }))
    }
  },
  methods: {
    onMultiSelectChange(value) {
      if (value) {
        this.selected = this.filteredItems
      } else {
        this.selected = []
      }
    },
    addFAT() {
      this.showSelect = true
      this.next = this.openFATDialog
    },
    deleteChangeCategoryMOCType(item) {
      this.selectedChangeCategoryMOCType = item
      this.showConfirmationDialog = true
    },
    onDeleteConfirmation() {
      this.showConfirmationDialog = false
      this.$emit('delete', this.selectedChangeCategoryMOCType)
      this.selectedChangeCategoryMOCType = undefined
    },
    cancelDeletion() {
      this.showConfirmationDialog = false
      this.selectedChangeCategoryMOCType = undefined
    },
    openFATDialog() {
      this.showSelect = false
      this.$emit('openFAT', this.selected, 'changeCategoryMocTypes')
      this.selected = []
    },
    onItemCheckboxChange(value, item) {
      if (value) {
        this.selected.push(item)
      } else {
        this.selected = this.selected.filter(s => s.clientID !== item.clientID)
      }
    },
    cancel() {
      this.selected = []
      this.showSelect = false
    },
    editChangeCategoryMOCType(item) {
      this.$emit('edit', item)
    }
  }
}
</script>
